(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.DeleteWeightSetDialog = (function(superClass) {
    extend(DeleteWeightSetDialog, superClass);

    function DeleteWeightSetDialog() {
      return DeleteWeightSetDialog.__super__.constructor.apply(this, arguments);
    }

    DeleteWeightSetDialog.prototype.init = function() {
      this.layoutUrl = 'backend/portal/weightings/load-delete-dialog';
      this.saveUrl = 'backend/portal/weightings/delete-weight-set';
      this.classes = 'small_dialog';
      this.refreshNavHandler = false;
      this.successAction = this.updateTaffy;
      return this.createDialog();
    };

    DeleteWeightSetDialog.prototype.afterLoadLayout = function() {
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          return _this.save('Deleting weight set...');
        };
      })(this));
      return this.openDialog();
    };

    DeleteWeightSetDialog.prototype.updateTaffy = function(response) {
      var szIDs, ws, zoneSel;
      ws = response.data;
      zoneSel = $(this.parent.layoutSelector).find('select[name="sel_assoc"]');
      szIDs = [];
      zoneSel.children().each(function() {
        return szIDs.push($(this).attr('value'));
      });
      zoneSel.val(szIDs);
      this.parent.deassocZones(false);
      this.parent.taffyObjects.ws({
        id: ws.id
      }).remove();
      this.parent.renderWeightSetSelect();
      return this.parent.renderZoneSelects();
    };

    return DeleteWeightSetDialog;

  })(DialogHandler);

}).call(this);
